<template>
	<OptionInput
		v-if="context.options"
		:model-value
		:options="context.options"
		@update:model-value="updateValue"
	/>
</template>

<script setup lang="ts">
import type { FormKitFrameworkContext } from "@formkit/core";
import OptionInput from "../input/OptionInput.vue";
import { computed } from "vue";

const props = defineProps<{
	context: FormKitFrameworkContext;
}>();

const modelValue = computed(() => props.context._value);

async function updateValue(value?: string | number | boolean) {
	await props.context.node.input(value);
}
</script>
